import React from "react";
import "./SubscriptionList.css";
import trashIcon from "./icons/CloseIcon.svg";
import folderIcon from "./icons/folder_icon.svg";
import DeleteSubscriptionMutation from "./mutations/DeleteSubscriptionMutation";
import { useTheme } from "./contexts/ThemeContext";

function SubscriptionList(props) {
  const theme = useTheme();
  const { subs } = props;
  props.refetch();
  function onSubDeleteClick(e) {
    e.preventDefault();
    console.log(e.target.dataset.id);
    // const subId = e.target.dataset.id;

    let subId = atob(e.target.dataset.id).split(":").pop();
    console.log(subId);
    DeleteSubscriptionMutation(subId, () => {
      console.log("Deleted the feed!");
    });
    // props.refetch();
  }

  function onFolderDeleteClick(e) {
    e.preventDefault();

    let subId = atob(e.target.dataset.id).split(":").pop();
    console.log(subId);
    DeleteSubscriptionMutation(subId, () => {
      console.log("Deleted the feed!");
    });
    console.log(e.target.dataset.id);
    // props.refetch();
  }

  return (
    <div className={`sublist-container theme-${theme.paragraph}`}>
      {subs.edges.map((edge, key) => (
        <div key={key}>
          {edge.node.parent == null ? (
            <div className={`parent-details`}>
              <div className={`parent-container`}>
                <span>{edge.node.name}</span>
                  {" "}
                  {/* <img
                    onClick={onFolderDeleteClick}
                    data-id={edge.node.id}
                    src={trashIcon}
                    alt={""}
                  ></img> */}
                  <button className="small-button-delete" onClick={onFolderDeleteClick} data-id={edge.node.id}>
                    Delete
                  </button>
              </div>
              <div className={`children-container`}>
                {subs.edges.map((childEdge, childKey) => (
                  <div key={childKey}>
                    {childEdge.node.parent != null ? (
                      <div>
                        {childEdge.node.parent.id === edge.node.id ? (
                          <div className={`child-source-details`}>
                            <div>
                              <span>
                                {childEdge.node.source.source_icon ? (
                                  <img
                                    width={18}
                                    height={18}
                                    className={`source-icon`}
                                    src={childEdge.node.source.source_icon}
                                    alt=""
                                  />
                                ) : (
                                  <span>
                                    {" "}
                                    &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                                  </span>
                                )}
                              </span>
                              <span>{childEdge.node.name} </span>
                            </div>
                              {/* <img
                                onClick={onSubDeleteClick}
                                data-id={childEdge.node.id}
                                src={trashIcon}
                                alt={""}
                              ></img> */}

                              <button
                                className="small-button-delete"
                                onClick={onSubDeleteClick}
                                data-id={childEdge.node.id}
                              >Delete</button>
                          </div>
                        ) : null}
                      </div>
                    ) : null}
                  </div>
                ))}

                <div className={`sublist-spacing`}></div>
              </div>
            </div>
          ) : null}
        </div>
      ))}
    </div>
  );
}

export default SubscriptionList;
